// Must stay self-contained: its source is inlined into the page via Function.prototype.toString.
// Coverage instrumentation would inject module-scope counters into that source, so istanbul must skip it.
/* istanbul ignore next */
function isLottolandNativeAppUserAgent(userAgent: string): boolean {
  const IPHONE_PATTERN = /iPhone/i;
  const LOTTOLAND_VERSION_PATTERN = /(^|\s)Lottoland\/(\d+(?:\.\d+){0,2})(\s|$)/i;
  const minimumAppVersion = [2, 0, 0] as const;

  const versionNumberFromParts = (major: number, minor: number, patch: number): number => major * 1_000_000 + minor * 1_000 + patch;

  if (!IPHONE_PATTERN.test(userAgent)) {
    return false;
  }

  const version = userAgent.match(LOTTOLAND_VERSION_PATTERN)?.[2];
  if (!version) {
    return false;
  }

  const [majorPart, minorPart = '0', patchPart = '0'] = version.split('.');
  return (
    versionNumberFromParts(Number(majorPart), Number(minorPart), Number(patchPart)) >= versionNumberFromParts(minimumAppVersion[0], minimumAppVersion[1], minimumAppVersion[2])
  );
}

export { isLottolandNativeAppUserAgent };
